import Box from '@mui/material/Box';
import { useState } from 'react';

export default function ExpandableText({
  text = '',
  limit = 100,
  moreLabel = 'View more',
  lessLabel = 'View less',
  sx = {},
}) {
  const [expanded, setExpanded] = useState(false);

  if (!text) return null;

  const isLong = text.length > limit;
  const displayText = expanded || !isLong ? text : `${text.slice(0, limit)}…`;

  return (
    <Box sx={sx}>
      <span className='expandable-text'>{displayText}</span>
      {isLong && (
        <button type='button' className='btn view-btn' onClick={() => setExpanded((p) => !p)}>
          {expanded ? lessLabel : moreLabel}
        </button>
      )}
    </Box>
  );
}
